import React, { useContext} from 'react';
import { IconButton } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import { LayerContext} from '../LayerContext';
import { loadLayerAndDispatch } from '../SideBar/AddAssetButton'

const AddGeneButton = ({ row, gene_field, map, genePMTilesLocation, catalogId }) => {

  const { dispatch } = useContext(LayerContext);

  const handleClick = (event) => {
    loadLayerAndDispatch(
      map.current,
      `${ genePMTilesLocation.endsWith('/') ? 
        genePMTilesLocation.slice(0, -1) : 
        genePMTilesLocation}/${row[gene_field]}.pmtiles`,
      'GENE',
      dispatch,
      false, // zoomTo
      catalogId
    );
  };

  return (
    <div>
      <IconButton
        aria-label="display gene"
        component="span"
        onClick={handleClick}
      >
        <AddIcon fontSize="small" />
      </IconButton>
      {row[gene_field]}
    </div >

  )
}

export default AddGeneButton;
